import { render } from "./ProjectModal.vue?vue&type=template&id=0fc39a1e&scoped=true"
import script from "./ProjectModal.vue?vue&type=script&lang=js"
export * from "./ProjectModal.vue?vue&type=script&lang=js"

import "./ProjectModal.vue?vue&type=style&index=0&id=0fc39a1e&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc39a1e"]])

export default __exports__